import { Box, Divider, Grid, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { CustomSwitch } from '../../shared';

export const TriggerFieldsSkeleton = ({ rows = 10 }) => {
  const renderSkeletonRows = () => {
    const skeletonRows = [];
    for (let i = 0; i < rows; i++) {
      skeletonRows.push(
        <Grid item xs={12} key={`skeleton-row-${i}`}>
          <Grid container spacing={2} className="flex-row-center-start">
            <Grid item xs={4}>
              <Box>
                <Typography className="text-sm-medium gray-700">
                  <Skeleton variant="text" width={100} height={30} />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <Box className="max-width-70">
                <Skeleton variant="rectangular" width={200} height={30} />
              </Box>
            </Grid>
          </Grid>
          <Divider className="border-1-gray mt-24px" />
        </Grid>
      );
    }
    return skeletonRows;
  };

  return <>{renderSkeletonRows()}</>;
};

export const FlowSettingsSkeleton = ({length = 6})=>{
  const boxes = Array.from({ length: length }, (_, index) => (
<Box display="flex" alignItems="center">
                <CustomSwitch
                  checked={false}
                  onChange={() => {}}
                />
                <Skeleton variant='text' width={400}/>
              </Box>
  ))
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2} className="flex-row">
            <Grid item xs={4}>
              <Box>
                <Typography className="text-sm-medium gray-700">
                  Configuration of import-export Veeva flows
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              {boxes}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

 
  export const FileSetupSkeleton = ({ length = 10 }) => {
    const boxes = Array.from({ length: length }, (_, index) => (
      <Box className='mt-1'>
        <Skeleton variant='text' width={'100%'} height={50} />
      </Box>
    ))
    return (
      <Grid container spacing={'24px'}>
      <Grid item xs={12}>
        <Box className="max-width-30">
          <Skeleton variant='rectangular' width={200} height={30}/>
        </Box>
      </Grid>
     
        <Grid item xs={12}>
          {boxes}
        </Grid>
      
    </Grid>
    ) 
  }
